import ISmimeAdapter from 'owa-smime-adapter/lib/adapter/ISmimeAdapter';
import getSigningCertificate from './getSigningCertificate';
import validateSigningCertificate from './validateSigningCertificate';
import saveSigningCertificate from '../actions/saveSigningCertificate';
import SmimeViewState from '../store/schema/SmimeViewState';

/**
 * This util selects the signing certificate and
 * validates the certificate by making server call.
 * @param smimeAdapter smimeAdapter
 * @param composeId composeId of compose to save the signingCertRawData in viewState
 * @param signingCertRawData signingcertRawData, passed if present, otherwise empty string.
 */
export default async function selectSigningCertificateAndValidate(
    smimeAdapter: ISmimeAdapter,
    smimeViewState: SmimeViewState
): Promise<string> {
    let certRawDataToVerify: string = smimeViewState.signingCertRawData;

    try {
        // Choose signing certificate
        if (!certRawDataToVerify) {
            certRawDataToVerify = await getSigningCertificate(smimeAdapter);
        }
        // Validate the signing certificate
        await validateSigningCertificate(certRawDataToVerify);
        !smimeViewState.signingCertRawData &&
            saveSigningCertificate(smimeViewState, certRawDataToVerify);
        return certRawDataToVerify;
    } catch (e) {
        return Promise.reject(e);
    }
}
